<script setup>
import {defineProps, computed} from 'vue'
import { Icon } from '@iconify/vue'
const props = defineProps({
  item:{}
})
const item = computed(()=>props.item)

// Handle image - support both string and array formats
const imageUrl = computed(() => {
  if (!item.value.image) return ''
  // If it's an array, take the first image
  if (Array.isArray(item.value.image)) {
    return item.value.image[0] || ''
  }
  // If it's a string, use it directly
  return item.value.image
})
</script>
<template>
  <div class="group h-48 md:h-80 rounded-xl bg-gradient-to-br from-white via-gray-50 to-gray-100 text-gray-900 shadow-xl overflow-hidden flex flex-col transition-all duration-300 ease-in-out hover:scale-[1.02] hover:shadow-2xl cursor-pointer">
    
    <div class="relative h-2/3 overflow-hidden">
      <img :src="imageUrl" :alt="item.nama" class="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-300 ease-in-out">
      <span :class="item.kategori === 'makanan'? 'bg-amber-400 text-white' : (item.kategori == 'minuman' ? 'bg-blue-400 text-white' : 'bg-white')" class="absolute top-2 left-2 h-10 w-10 flex items-center justify-center  text-xs font-semibold px-2 py-1 rounded-full opacity-90 shadow-md">
        <Icon v-if="item.kategori == 'minuman'" icon="icon-park-solid:tea-drink" class="size-8"/>
        <Icon v-if="item.kategori == 'makanan'" icon="mdi:food-ramen" class="size-8"/>
        <Icon v-if="item.kategori == 'dessert'" icon="fluent:food-cake-12-filled" class="size-8"/>
      </span>
    </div>

    <div class="p-4 flex flex-col justify-between flex-grow">
      <h3 class="text-base md:text-lg font-semibold text-gray-800 line-clamp-2 leading-tight mb-1">{{ item.nama }}</h3>
      <p class="text-xs md:text-sm text-gray-500 mb-2 line-clamp-2 h-12">{{ item.description }}</p> <div class="mt-auto flex justify-between items-end">
        <p class="text-xl md:text-2xl font-bold text-amber-600">{{ item.harga }}</p>
        </div>
    </div>
  </div>
</template>